<template>
       <v-row 
          v-if="processing"
          align="center"
          justify="center"
      >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card flat color="transparent">
              <v-card-text class="pb-0">
                  <p class="text-center"><img src="../assets/logo-large.png" /></p>
                  <v-row align="center" justify="center">
                      <v-col cols="10">
                          <p class="text-center">
                              <v-progress-linear
                                  indeterminate
                                  color="primary"
                                  height="5"
                                  class="mt-5"
                                  rounded
                              ></v-progress-linear>
                          </p>
                      </v-col>
                  </v-row>
              </v-card-text>
            </v-card>
          </v-col>
      </v-row>
      <v-container v-else-if="permissionStatus == ''" fluid>
        <v-row
          no-gutters
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="5"
          >
            <v-card outlined>
                <v-card-text>
                    <div class="text-center">
                        <v-icon color="grey lighten-2" size="100">mdi-alert-circle</v-icon>
                    </div>
                    <div class=" mt-2 text-center text--primary text-h6 font-weight-regular">The link is either invalid or your invitation was revoked.</div>
                </v-card-text>
                <v-card-actions class="mt-2">
                    <v-btn width="150" to="/login" color="primary" block depressed large class="text-body-1">Go to Log In</v-btn>
                </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else-if="permissionStatus != 'invited'" fluid>
        <v-row
          no-gutters
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="5"
          >
            <v-card outlined>
                <v-card-text>
                    <div class="text-center">
                        <v-icon color="grey lighten-2" size="85">mdi-alert-circle</v-icon>
                    </div>
                    <div class=" mt-2 text-center text--primary text-h6 font-weight-regular">This link has expired.</div>
                </v-card-text>
                <v-card-actions class="mt-2">
                    <v-btn width="150" to="/login" color="primary" block depressed large class="text-body-1">Go to Log In</v-btn>
                </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else fluid>
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
        >
        <v-card outlined :loading="loading">
          <v-row>
            <v-col class="py-0">
              <v-card>
                <v-card-title class="font-weight-regular text-h5">Welcome</v-card-title>
                <v-card-subtitle>Register below to activate your Business Portal access.</v-card-subtitle>
                <v-form
                  ref="form"
                  v-model="valid"
                  @submit.prevent="registerUser"
                >
                  <v-card-text>
                      <v-alert
                        text
                        prominent
                        color="primary"
                        icon="priority_high"
                        v-if="error!=''"
                      >
                        <v-row align="center" no-gutters>
                          <v-col class="grow">{{error}}</v-col>
                        </v-row>
                      </v-alert>
                      <v-text-field
                        label="Email"
                        name="email"
                        readonly
                        outlined
                        type="text"
                        v-model="email"
                        dense
                        :validate-on-blur="isFirstSubmissionAttempt"
                      ></v-text-field>
                      <v-row>
                        <v-col cols="12" md="6" class="my-0 py-0">
                          <v-text-field
                            label="First Name"
                            name="firstName"
                            outlined
                            type="text"
                            v-model="firstName"
                            dense
                            :rules="nameRules"
                            :validate-on-blur="isFirstSubmissionAttempt"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6"  class="my-0 py-0">
                          <v-text-field
                            label="Last Name"
                            name="lastName"
                            outlined
                            type="text"
                            v-model="lastName"
                            dense
                            :rules="nameRules"
                            :validate-on-blur="isFirstSubmissionAttempt"
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-text-field
                        id="password"
                        label="Password"
                        name="password"
                        outlined
                        v-model="password"
                        dense
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show1 ? 'text' : 'password'"
                        hint="At least 8 characters"
                        counter
                        @click:append="show1 = !show1"
                        :validate-on-blur="isFirstSubmissionAttempt"
                        :rules="passwordRules"
                      ></v-text-field>
                      <v-text-field
                        id="confirmPassword"
                        label="Confirm Password"
                        name="confirmPassword"
                        outlined
                        v-model="confirmPassword"
                        dense
                        :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'"
                        counter
                        @click:append="show2 = !show2"
                        :rules="[() => password == confirmPassword || 'The passwords don\'t match', v => !!v || 'Please retype your password']"
                      ></v-text-field>
                      <v-row align="center" no-gutters>
                        <v-col class="grow">
                          <div class="text-center text-body-2 grey--text">By continuing you agree to the <br>Pappyon <a class="grey--text text--darken-1 font-weight-bold text-decoration-none" :href="termsOfUseUrl">Terms of Use</a>  and <a class="grey--text text--darken-1 font-weight-bold text-decoration-none" :href="privacyPolicyUrl">Privacy Policy</a></div>
                        </v-col>
                      </v-row>
                      
                  </v-card-text>
                  <v-card-actions class="px-4 pt-0">
                      <v-btn elevation="0" block type="submit" color="primary" large class="px-5 mb-3 text-body-2">Agree and Sign Up</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
        </v-col>
      </v-row>
      </v-container>
</template>
<script>
// @ is an alias to /src

import { mapGetters } from 'vuex';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import {
  getHttpsCallable,
  getAuth,
  setUsersDoc,
  getQueryBusinessPortalAccessCollection,
  updateUserDoc
} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";

export default {
  name: 'PortalAccessInvitation',
  data() {
    return{
      processing: true,
      email: '',
      firstName: '',
      lastName: '',
      password: '',
      confirmPassword: '',
      error: '',
      loading: false,
      show1: false,
      show2: false,
      valid: false,
      isFirstSubmissionAttempt: true,
      nameRules: [
        v => !!v || 'This field is required',
      ],
      passwordRules: [
        v => !!v || 'Please enter your password',
        v => v.length >= 8 || 'The password must be at least 8 characters long',
      ],
      permissionId: '',
      businessProfileId: '',
      permissionStatus: '',
      auth: getAuth()
    };
  },
  async created() {
    try{
      this.permissionId = this.$route.params.permissionId;
      //Read the document
      let permissionDocRef = await getBusinessPortalAccessDoc(this.permissionId);
      if (permissionDocRef.exists) {
        let data = permissionDocRef.data()
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.businessProfileId = data.businessProfileId;
        this.permissionStatus = data.status
    } else {
        // permissionDocRef.data() will be undefined in this case
        console.log("No such document!");
    }
    } catch(error) {
      console.log(error);
    }
    this.processing = false;
  },
  methods: {
    async  registerUser() {
       if (this.$refs.form.validate()) {
          try {

            //Start: Register user using firebase auth
            this.loading = true;
            let userCredential = await createUserWithEmailAndPassword(this.auth, this.email,this.password);
            let newlyRegisteredUser = userCredential.user;
            console.log('The user was registered successfully');
            //End: Register user using firebase auth
            //Start: Set isEmailVerified to true
            const setEmailVerificationToTrue = getHttpsCallable('setEmailVerificationToTrue');
            await setEmailVerificationToTrue({}).then( async result => {
              await this.auth.currentUser.reload();
            }).catch(error => {
                console.log("In the setEmailVerificationToTrue catch");
            });
            //End: Set isEmailVerified to true
            //Start: Add an new user document in firestore
            await setUsersDoc(this.auth.currentUser.uid, {
              firstName: this.firstName,
              lastName: this.lastName,
              email: this.email,
              creationDate: new Date(),
              lastLoginDate: new Date(),
              lastLoggedInPlatform: 'business-portal',
              hasLoggedInToBusinessPortal: true,
            });

            
            //End: Add an new user document in firestore
            //Start: Attach any business portal access permissions that have the same email as the newly registered user 
            let usersBusinessPortalAccessPermissions = await getQueryBusinessPortalAccessCollection(
                where('email', '==', newlyRegisteredUser.email.toLowerCase()),
                where('status', '==', 'invited')
            );

            //Iterate through each element in usersBusinessPortalAccessPermissions.docs array in parallel 
            //but await the async processing of each element in the usersBusinessPortalAccessPermissions.docs array
            await Promise.all(usersBusinessPortalAccessPermissions.docs.map(async (businessPortalAccessDocRef) => {
              //Update the uid of every business portal access document and update their status to active
              await updateUserDoc(businessPortalAccessDocRef.id, {
                uid: newlyRegisteredUser.uid,
                status: 'active',
              });

            }));
            //End: Attach any business portal access permissions that have the same email as the newly registered user 
            if(usersBusinessPortalAccessPermissions.empty) {
              //The user does not have any businesss portal access permissions
            }
            this.$router.push('/businessAccounts');
          } catch(err) {
            this.error = err.message;
            this.loading = false;
          }
      } else {
        this.isFirstSubmissionAttempt = false;
        this.error=''
      }
    },
  },
  computed: {
      ...mapGetters(['termsOfUseUrl', 'privacyPolicyUrl']),
      passwordConfirmationRule() {
        return () => (this.password === this.confirmPassword) || 'Password must match'
      },
  }
}
</script>